export default __webpack_public_path__ + "static/media/homeImage_Green.4e103ac7.png";